import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { env } from '@/utils/env';
import ScrollToTop from '@/components/common/ScrollToTop';
import { PencomRoutes } from '@/router/PencomRoutes';
import PencomLogo from './PencomLogo';
import { OnboardingStepIndicator } from '@/components/onboarding/OnboardingStepIndicator';
import { isOnboardingStepPath } from '@/constants/onboardingSteps';
import { NeedHelpDropdown } from "@/components/common/NeedHelpDropdown";
import { PencomFooter } from "./PencomFooter";

const PlainLayout = () => {
    const location = useLocation();
    const showStepIndicator = isOnboardingStepPath(location.pathname);

    const getPageTitle = () => {
        switch (location.pathname) {
            case '/onboarding/welcome':
                return 'Welcome - Onboarding';
            case PencomRoutes.LOGIN:
                return 'Login - PenCom Employer Hub';
            case '/onboarding/verification':
                return 'Verification - Onboarding';
            default:
                return 'Onboarding';
        }
    };

    return (
        <>
            <ScrollToTop />
            <Helmet>
                <title>{`${getPageTitle()} - ${env.APP_NAME}`}</title>
                <meta name="description" content={`Employee Hub Onboarding`} />
            </Helmet>

            <div className="relative flex flex-row min-h-screen bg-off-white">
                <div className="w-1/3">
                    <PencomLogo className="text-dark-brown text-[24px]" />
                </div>
                <div className="flex flex-col min-h-screen w-[509px] max-w-full">
                    <div className="flex-1 mt-15 pb-10">
                        {showStepIndicator && <OnboardingStepIndicator />}
                        <NeedHelpDropdown className="mb-6" />
                        <Outlet />
                    </div>
                    <PencomFooter />
                </div>
            </div>
        </>
    );
};

export default PlainLayout;
